import { MfeConfig } from '@carvana/microfrontend';
import { MfeReact } from '@carvana/microfrontend-react';
import { AnalyticsPlugin } from '@carvana/microfrontend-plugins';

const config = () =>
  MfeConfig(
    {
      name: 'tradesUi',
      Render: MfeReact(),
      ENV: process.env.NODE_ENV as any,
      globals: {
        React: () => import('react'),
        ReactDOM: () => import('react-dom'),
        styled: () => import('styled-components'),
        'styled-components': () => import('styled-components'),
        PropTypes: () => import('prop-types'),
        'prop-types': () => import('prop-types')
      }
    },
    {
      plugins: [
        AnalyticsPlugin({
          repository: 'STC.Home',
        })
      ]
    }
  );

export default config;
